// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useGetDashboardTransactionList,
  useGetDashboardBankList,
  useGetUnPaidPaymentTotal
} from "../hooks";
import { Stack } from "@mui/system";
import { AdminTemplate, DashboardWidget } from "../components";
import { useEffect } from "react";
import {
  Container, Grid, useMediaQuery, useTheme, Box,
  IconButton,
  Link,
  Modal,
  Typography,
  Paper
} from "@mui/material";
import { AccountBalanceWallet } from "@mui/icons-material";
import { useUserInfo } from '../store/User.state';

export const Dashboard = () => {
  const theme = useTheme();
  const userInfo = useUserInfo();

  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const isWideScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const { data: dashboardTransactionList, mutate: getDashboardTransactionList } =
    useGetDashboardTransactionList();
  const { data: dashboardBankList, mutate: getDashboardBankList } = useGetDashboardBankList();
  const { data: unPaidPaymentTotal, mutate: getUnPaidPaymentTotal } = useGetUnPaidPaymentTotal();
  const formatNumberToCurrency = (numberStr) => {
    if (numberStr === null || numberStr === undefined) {
      return "-";
    }
    const stringValue = String(numberStr);
    let adjustedNumber = parseFloat(stringValue.replace(',', '.'));

    // Sayıyı belirtilen formatta formatlıyoruz
    let formattedNumber = new Intl.NumberFormat('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(adjustedNumber);

    return formattedNumber
  }

  useEffect(() => {
    getDashboardTransactionList(
      { period: "DAILY" },
    );
  }, [getDashboardTransactionList]);

  useEffect(() => {
    getDashboardBankList(
      { period: "DAILY" },
    );
  }, [getDashboardBankList]);

  useEffect(() => {
    getUnPaidPaymentTotal();
  }, [getUnPaidPaymentTotal]);

  const handleTransaction = (
    value: "DAILY" | "WEEKLY" | "MONTHLY" | "YEARLY"
  ) => {
    getDashboardTransactionList(
      { period: value },
    );
  };

  const handleBankList = (value: "DAILY" | "WEEKLY" | "MONTHLY" | "YEARLY") => {
    getDashboardBankList(
      { period: value },
    );
  };
  const isLargeScreen = useMediaQuery('(min-width: 1440px)');

  const isMerchantUser = localStorage.getItem('merchantId') !== '0';

  return (
    <AdminTemplate
      headerProps={{ headerTitle: "Ana Ekran", hideAddButton: true }}
    >
      <Box sx={{ flexGrow: 1, p: isDesktop ? 3 : 1, backgroundColor: 'rgb(246 247 248 / 1) !important' }}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={isMerchantUser ? 12 : 8}>
            <DashboardWidget
              onDateClick={handleTransaction}
              items={dashboardTransactionList?.data?.map(item => ({ ...item })) || []}
              widgetTitle="Satış Tipi"
            />
          </Grid>

          {isMerchantUser === false && (
            <Grid item xs={12} lg={4}>
              <Stack sx={{ boxShadow: 2, borderRadius: 3, px: isDesktop ? 3 : 1, py: isDesktop ? 4 : 2, height: '100%', backgroundColor: '#fff' }}>
                <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                  <AccountBalanceWallet />
                  <Typography variant="h4">
                    Bekleyen Hakedişler
                  </Typography>
                </Stack>
                <Stack spacing={2}>
                  {unPaidPaymentTotal?.data?.map((item, index) => (
                    <Paper key={index} elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Stack flexGrow={1}>
                          <Typography variant="h6">{item.name}</Typography>
                          <Typography variant="body1" fontWeight="bold">{formatNumberToCurrency(item.total.toString())} TL</Typography>
                        </Stack>
                      </Stack>
                    </Paper>
                  ))}
                </Stack>
              </Stack>
            </Grid>
          )}

          <Grid item xs={12}>
            <DashboardWidget
              onDateClick={handleBankList}
              items={dashboardBankList?.data?.map(item => ({ ...item })) || []}
              widgetTitle="Banka Satış"
            />
          </Grid>
        </Grid>
      </Box>
    </AdminTemplate>
  );
};
